export default __webpack_public_path__ + "static/media/nest2.559a3fea.png";